import { Box, Button, Stack, Typography, Paper, Divider } from "@mui/material";
import { UseFieldArrayReturn } from "react-hook-form";
import { ReactNode } from "react";

type Props<TItem> = {
  label?: string;
  disabled?: boolean;
  defaultItem: TItem;
  fieldArray: UseFieldArrayReturn<any, any, "id">;
  renderItem: (index: number) => ReactNode;
};

function ArrayFieldWrapper<TItem>({
  label,
  disabled = false,
  defaultItem,
  fieldArray,
  renderItem,
}: Props<TItem>) {
  const { fields, append, remove } = fieldArray;

  return (
    <Box>
      {label && (
        <Typography variant="h6" gutterBottom>
          {label}
        </Typography>
      )}

      <Stack spacing={4}>
        {fields.map((field, index) => (
          <Paper
            key={field.id}
            variant="outlined"
            sx={{
              p: 3,
              borderRadius: 2,
            }}
          >
            <Stack spacing={2}>
              <Typography variant="subtitle1" fontWeight={600}>
                {`${label || "Item"} ${index + 1}`}
              </Typography>

              {renderItem(index)}

              <Divider
                sx={{
                  my: 4,
                }}
              />

              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="outlined"
                  color="error"
                  disabled={disabled}
                  onClick={() => remove(index)}
                >
                  Remove
                </Button>
              </Box>
            </Stack>
          </Paper>
        ))}

        <Box mt={2}>
          <Button
            variant="outlined"
            onClick={() => append(defaultItem, { shouldFocus: false })}
            disabled={disabled}
          >
            Add {label || "Item"}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}

export default ArrayFieldWrapper;
